export default __webpack_public_path__ + "static/media/blog-service-landing.0d9a3c0a.png";